import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalVariable } from '.././config/service.config';
import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authservice: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    //Verificar token
    const token = this.authservice.getToken();
    if (token == null) {
      this.router.navigateByUrl('/login');
    }
    const payload = helper.decodeToken(token);
    const expidaro = this.expirado(payload.exp);

    if (expidaro) {
      console.log('Token a Expirado!..');
      setTimeout(() => {
        this.authservice.logOffFull();
      }, 6000);
      return false;
    }
    return this.verificaRenueva(payload.exp);
  }

  Encoding(v: string): string {

    return encodeURIComponent(v)

      .replace(/%40/gi, '@')

      .replace(/%3A/gi, ':')

      .replace(/%24/gi, '$')

      .replace(/%2C/gi, ',')

      .replace(/%3B/gi, ';')

      .replace(/%2B/gi, '+')

      .replace(/%3D/gi, '=')

      .replace(/%3F/gi, '?')

      .replace(/%2F/gi, '/');

  }

  expirado(fechaExp: number) {
    const ahora = new Date().getTime() / 1000;
    if (fechaExp < ahora) {
      return true;
    } else {
      return false;
    }
  }
  
  verificaRenueva(fechaExp: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const tokenExp = new Date(fechaExp * 1000);
      const ahora = new Date();

      // aumentar en 4 horas el token
      ahora.setTime(ahora.getTime() + (GlobalVariable.TimerToken));
      if (tokenExp.getTime() > ahora.getTime()) {
        resolve(true);
      } else {
        // renovar token
        this.authservice.refreshToken().subscribe(
          (data) => {
            this.authservice.setRefToken(data);
            resolve(true);
          },
          (err) => {
            reject(false)
          }

        );
      }
    });
  }

}
